<cm-routed-dialog [dialogSize]="dialogSizes.Large" [dialogScroll]="false" (close)="overlayClosed()">
    <ng-container cm-overlay-content>
        <i class="far fa-chevron-left cm-back-icon" (click)="overlayClosed()"></i>
        <cm-configurator [templateUuid]="$templateId()" [showUi]="true" [forceWebGl]="false"></cm-configurator>
    </ng-container>
</cm-routed-dialog>
